import { css } from "@compiled/react";

import { Picture } from "@/components/wpl/image/src/image";

export const RovoDevAgentsLogo = () => {
    const cmsLogoStyle = css({
        height: "48px"
    });

    return (
        <Picture
            image={{
                src: `https://dam-cdn.atl.orangelogic.com/AssetLink/5t47pkm4i4ohq647450a58xbtp5m5f08.svg`,
                alt: "Rovo Dev Logo"
            }}
            css={cmsLogoStyle}
            key={"devai.ondemand"}
        />
    );
};
